import { render, staticRenderFns } from "./BasicLoading.vue?vue&type=template&id=18dfb4ab"
import script from "./BasicLoading.vue?vue&type=script&lang=js"
export * from "./BasicLoading.vue?vue&type=script&lang=js"
import style0 from "./BasicLoading.vue?vue&type=style&index=0&id=18dfb4ab&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports